module.exports = __webpack_public_path__ + "static/customer-profile-42d7798e39476b690e21915c70a73973.png";